import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Scale, Phone, MessageCircle, Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navItems = [
    { name: 'Home', path: '/' },
    { name: 'About Us', path: '/about' },
    { name: 'Why Us', path: '/why-us' },
    { name: 'Our Services', path: '/services' },
    { name: 'Criminal', path: '/criminal' },
    { name: 'Office Location', path: '/location' },
    { name: 'Contact Us', path: '/contact' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="bg-[#000A22] text-white sticky top-0 z-50 shadow-lg">
      <div className="container mx-auto px-6">
        <div className="flex items-center justify-between py-4">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3 group">
            <div className="w-12 h-12 bg-[#D4A74A] rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
              <Scale className="w-7 h-7 text-[#000A22]" />
            </div>
            <div>
              <div className="text-xl font-bold tracking-tight">Pattaya Solicitors</div>
              <div className="text-xs text-[#D4A74A] font-medium">Legal Excellence in Thailand</div>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-1">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`px-4 py-2 rounded-lg font-medium transition-all duration-300 ${
                  isActive(item.path)
                    ? 'bg-[#D4A74A] text-[#000A22]'
                    : 'text-white hover:bg-white/10'
                }`}
              >
                {item.name}
              </Link>
            ))}
          </nav>

          {/* Desktop CTA Buttons */}
          <div className="hidden lg:flex items-center gap-3">
            <Button
              size="sm"
              className="bg-[#D4A74A] hover:bg-[#C69A3E] text-[#000A22] font-semibold transition-all duration-300 hover:scale-105"
              asChild
            >
              <a href="tel:+6638412415">
                <Phone className="w-4 h-4 mr-2" />
                Call Now
              </a>
            </Button>
            <Button
              size="sm"
              variant="outline"
              className="border-2 border-white text-white hover:bg-white hover:text-[#000A22] font-semibold transition-all duration-300"
              asChild
            >
              <Link to="/contact">
                <MessageCircle className="w-4 h-4 mr-2" />
                Chat
              </Link>
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden p-2 hover:bg-white/10 rounded-lg transition-colors"
          >
            {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="lg:hidden py-4 border-t border-white/10">
            <nav className="flex flex-col gap-2">
              {navItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={() => setIsMenuOpen(false)}
                  className={`px-4 py-3 rounded-lg font-medium transition-all duration-300 ${
                    isActive(item.path)
                      ? 'bg-[#D4A74A] text-[#000A22]'
                      : 'text-white hover:bg-white/10'
                  }`}
                >
                  {item.name}
                </Link>
              ))}
              
              <div className="flex flex-col gap-2 mt-4 pt-4 border-t border-white/10">
                <Button
                  className="bg-[#D4A74A] hover:bg-[#C69A3E] text-[#000A22] font-semibold w-full"
                  asChild
                >
                  <a href="tel:+6638412415">
                    <Phone className="w-4 h-4 mr-2" />
                    Call Now
                  </a>
                </Button>
                <Button
                  variant="outline"
                  className="border-2 border-white text-white hover:bg-white hover:text-[#000A22] font-semibold w-full"
                  asChild
                  onClick={() => setIsMenuOpen(false)}
                >
                  <Link to="/contact">
                    <MessageCircle className="w-4 h-4 mr-2" />
                    Chat With Us
                  </Link>
                </Button>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
